var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "city-handler__container" },
    [
      _c("span", [_vm._v("Ваш город:")]),
      _c(
        "btn",
        {
          staticClass: "city-handler__toggler",
          attrs: { tag: "control" },
          nativeOn: {
            click: function($event) {
              return _vm.showModalChoise($event)
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.currentDomain) + "\n\t\t\n\t")]
      ),
      _c(
        "page-overlay",
        {
          attrs: { show: _vm.overlayIsShow, width: 588, "auto-height": true },
          on: { close: _vm.closeModalChoise }
        },
        [
          _c("h3", { staticClass: "city-handler__form-title" }, [
            _vm._v("Выбор города")
          ]),
          _c(
            "ul",
            { staticClass: "city-handler__list" },
            _vm._l(_vm.domains, function(domain) {
              return _c(
                "li",
                { staticClass: "city-handler__item" },
                [
                  _c(
                    "btn",
                    {
                      staticClass: "city-handler__item__btn",
                      attrs: { tag: "control" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.goToHost(domain.host)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(domain.name) + "\n\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2ec5c58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2ec5c58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CityHandler.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e2ec5c58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CityHandler.vue
// module chunks = 5